type Steps =
  | "register"
  | "profession"
  | "employment-type"
  | "details"
  | "vehicle"
  | "license";

export const useGetSteps = () => {
  return ({
    isMultipleProfessions,
    isMultipleEmploymentTypes,
    formRequirements,
    currentStep,
    employmentType,
    isLoginWithPro,
  }: {
    isMultipleProfessions?: boolean;
    isMultipleEmploymentTypes?: boolean;
    formRequirements?: {
      vehicle: string;
      license: string;
    };
    currentStep: Steps;
    employmentType?:
      | "selfemployed"
      | "individual_entrepreneur"
      | "park_employee";
    isLoginWithPro?: boolean;
  }) => {
    const navigationSteps: Steps[] = ["register"];
    let progressSteps = ["register"];

    if (isMultipleProfessions) {
      navigationSteps.push("profession");
      progressSteps.push("profession");
    }

    if (isMultipleEmploymentTypes) {
      navigationSteps.push("employment-type");
      progressSteps.push("employment-type");
    }

    if (isMultipleEmploymentTypes || employmentType !== "park_employee") {
      progressSteps.push("details");
      if (
        (employmentType === "selfemployed" ||
          employmentType === "individual_entrepreneur") &&
        (isLoginWithPro || isMultipleEmploymentTypes || isMultipleProfessions)
      ) {
        navigationSteps.push("details");
      }
    }

    if (formRequirements?.vehicle !== "none") {
      navigationSteps.push("vehicle");
      progressSteps.push("vehicle");
    }

    if (formRequirements?.license !== "none") {
      progressSteps.push("license");

      if (employmentType === "park_employee") {
        navigationSteps.push("license");
      }
    }

    const progressIndex = progressSteps.findIndex(
      (step) => step === currentStep,
    );
    const navigationIndex = navigationSteps.findIndex(
      (step) => step === currentStep,
    );

    const nextStep =
      navigationIndex !== -1 ? navigationSteps[navigationIndex + 1] : undefined;
    const currentStepIndex = nextStep
      ? progressIndex !== -1
        ? progressIndex + 1
        : undefined
      : progressSteps.length;

    return {
      currentStep: currentStepIndex,
      stepsCount: progressSteps.length,
      nextStep,
    };
  };
};
